import React from 'react';

export const IconArrowDown = () => (
  <svg width="16" height="16" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M9.75592 4.75105C10.0814 5.08579 10.0814 5.6285 9.75592 5.96323L5.58926 10.2489C5.26382 10.5837 4.73618 10.5837 4.41074 10.2489L0.244078 5.96323C-0.0813595 5.6285 -0.0813595 5.08579 0.244078 4.75105C0.569514 4.41632 1.09715 4.41632 1.42259 4.75105L5 8.43067L8.57741 4.75105C8.90285 4.41632 9.43049 4.41632 9.75592 4.75105Z" />
  </svg>
);
